import {stateData, reduxState} from '../../values';

const initialState = {
    reports:        [],
    status:         stateData.state1,
    reportsEdit:    [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_reports){
        return {
            ...state,
            reports:    action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_reports){
        return {
            ...state,
            reportsEdit: action.payload
        }
    }
    return state
}
export default reducer